export default "<h1>Type2LongString list</h1>\n<spec-app-type2-long-string-table [clickHandler]=\"createClickHandler()\"></spec-app-type2-long-string-table>";